import { getEngineerDataResponseSchema } from '@sky-distribution/gp-onboarding-client-data-service';
import { Contact } from '@sky-distribution/adapter-core-pc-rest-interfaces/core/rest/v2/Policy.type';

export const getEngineerData = (data: unknown): Contact => {
  const parsedData = getEngineerDataResponseSchema.safeParse(data);

  if (parsedData.success) {
    const {
      name,
      lastName,
      email,
      flatNumber,
      houseNumber,
      mobilePhone,
      street,
      postalCode,
      city,
    } = parsedData.data;

    return {
      firstName: name,
      lastName,
      emailAddress1: email,
      homeNumber: mobilePhone,
      primaryAddress: {
        addressLine1: street,
        addressLine2: houseNumber,
        addressLine3: flatNumber,
        city,
        postalCode,
      },
    };
  }

  return {};
};
